import _ from 'lodash';
import { makeCell } from './gridUtill';
let fields = [];
let columns = [];
const data = [
  {
    field: 'report_idx',
    alias: 'report_idx',
  },
  {
    field: 'lotNo',
    alias: 'Lot No',
  },
  {
    // 저장값은 원본 코드지만 화면에는 원산지 제한 접미사까지 붙은 표기값을 쓴다.
    // 정렬과 필터도 이 컬럼 기준으로 돌아간다.
    field: 'display_code',
    alias: 'Code Grade',
  },
  {
    field: 'qty',
    alias: '수량',
  },
  {
    field: 'out_due_date',
    alias: '출하예정일',
  },
  {
    field: 'request_name',
    alias: '요청자',
  },
  {
    field: 'request_company',
    alias: '요청업체명',
  },
];

_.each(data, function (o) {
  o.indexExclusive = true;
  makeCell(1, [o], fields, columns);
});
export { fields, columns };
